import sales from './sales/routes';
import product from './product/routes';
import service from './service/routes';
import shift from './shift/routes';
// import cash from './cash/routes';
import { calendarRoute } from '@/views/calendar_route';

const routes = [
  {
    path: '/',
    alias: '/home-dashboard',
    name: 'Home',
    meta: { hidePageHeader: true },
    icon: 'mdi-home',
    component: () => import('./Dashboard.vue'),
  },
  {
    path: '/multiClientTest',
    name: 'Multi Client Test',
    component: () => import('./templates/ReportTemplate.vue'),
  },
  sales,
  product,
  service,
  shift,
  // cash,
  calendarRoute,
];

export default routes;
